<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            sort-by="calories"
            class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Servis Takip</v-toolbar-title>
                <v-divider
                        class="mx-4"
                        inset
                        vertical
                ></v-divider>
                 <v-text-field
                    v-model="search"
                    append-icon="mdi-search"
                    label="Ara"
                    single-line
                    hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-row justify="center">
                  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card style="text-align:left">
                        <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{editedItem.urun + " " + editedItem.urunmarka + " " + editedItem.urunmodel}}</v-toolbar-title>
                        </v-toolbar>
                        <v-list three-line subheader>
                        <v-subheader>Servis Takip Bilgileri</v-subheader>
                        <v-list-item>
                            <v-list-item-content>
                            <v-list-item-title>Teslim Alım Tarihi</v-list-item-title>
                            <v-list-item-subtitle>{{cDate(editedItem.teslimalimtarihi)}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                            <v-list-item-title>Teslim Edilme Tarihi</v-list-item-title>
                            <v-list-item-subtitle>{{cDate(editedItem.teslimetmetarihi)}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                            <v-list-item-title>Durumu</v-list-item-title>
                            <v-list-item-subtitle>
                                <v-chip :color="getColor(editedItem.durumu)" dark>{{editedItem.durumu}}</v-chip>
                            </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                            <v-list-item-title>Sorunlar</v-list-item-title>
                            <v-list-item-subtitle>{{editedItem.sorunlar}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                            <v-list-item-title>Yapılanlar</v-list-item-title>
                            <v-list-item-subtitle>{{editedItem.yapilanlar}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                            <v-list-item-title>Toplam Ücret </v-list-item-title>
                            <v-list-item-subtitle>{{editedItem.toplamucret}} TL </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                    </v-card>
                </v-dialog>
            </v-row>

               <!-- <v-dialog v-model="dialog" max-width="600px">
                        <v-card 
                           class="mx-auto"
                           outlined
                        >
                            <v-card-title class="blue darken-1">
                            <span class="headline white--text">{{editedItem.urun + " " + editedItem.urunmarka + " " + editedItem.urunmodel}}</span>
                            </v-card-title>
                            <v-list style="text-align:left">
                            <v-list-item>
                                <v-list-item-action>
                                <v-icon>mdi-text</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                <v-list-item-title>Durumu  : {{editedItem.durumu}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider inset></v-divider>
                            <v-list-item >
                                <v-list-item-action>
                                <v-icon>mdi-text</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                <v-list-item-title>Teslim Alim Tarihi : {{editedItem.teslimalimtarihi}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider inset></v-divider>
                            <v-list-item >
                                <v-list-item-action>
                                <v-icon>mdi-text</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                <v-list-item-title>Teslim Edilme Tarihi : {{editedItem.teslimetmetarihi}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </v-list>
                            <v-card >
                                <v-card-title class="red darken-1">
                                <span class="headline white--text">Sorunlar</span>
                                </v-card-title>
                                <v-card-content style="text-align:left">
                                    <h4>{{editedItem.sorunlar}}</h4>
                                </v-card-content>
                            </v-card>
                            <v-card>
                                <v-card-title class="green darken-1">
                                <span class="headline white--text">Yapılanlar</span>
                                </v-card-title>
                                <v-card-content style="text-align:left">
                                    <h4>{{editedItem.yapilanlar}}</h4>
                                </v-card-content>
                            </v-card>
                        </v-card>
                </v-dialog>-->
            </v-toolbar>
        </template>
        <template v-slot:item.teslimalimtarihi="{ item }">
           {{cDate(item.teslimalimtarihi)}}
        </template>
        <template v-slot:item.teslimetmetarihi="{ item }">
            {{cDate(item.teslimetmetarihi)}}
        </template>
        <template v-slot:item.durumu="{ item }">
            <v-chip :color="getColor(item.durumu)" dark>{{item.durumu}}</v-chip>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
            >
                mdi-text
            </v-icon>
        </template>
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
</template>

<script>
    import { loadProgressBar } from 'axios-progress-bar'
    export default {
        data: () => ({
            search: '',
            dialog: false,
            headers: [
                { text: 'Urun', value: 'urun' },
                { text: 'Marka', value: 'urunmarka' },
                { text: 'Model', value: 'urunmodel' },
                { text: 'Durumu', value: 'durumu' },
                {
                    text: 'Teslim Alım Tarihi', 
                    value: 'teslimalimtarihi',
                },
                {
                    text: 'Teslim Edilme Tarihi',
                    value: 'teslimetmetarihi',
                },
                { text: 'Detaylar', value: 'action', sortable: false },

            ],
            items: [],
            editedIndex: -1,
            file:new Blob([]),
            editedItem: {
                id:'',
                title: '',
                short_description: '',
                long_description: '',
                audio_url:''
            }
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Ekle' : 'Düzenle'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },

        created () {
            this.initialize()
        },

        methods: {  
            initialize () {
                loadProgressBar(this.axios.config,this.axios);
                this.$axios.get("service").then(response=>{
                     this.items = response.data;
                });
                //this.items = []
            },
            getColor (durum) {
                if(durum == "DEVAM EDİYOR"){
                    return "blue";
                }
                if(durum == "ONAY BEKLİYOR"){
                    return "red";
                }
                if(durum == "HAZIR"){
                    return "green";
                }
                if(durum == "TESLİM EDİLDİ"){
                    return "gray";
                }
                return "";
            },
            cDate(sd){
                if(typeof sd == "string"){
                    return sd.split("T")[0];
                }else{
                    return sd;
                }
            },
            editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            }
        },
    }
</script>

<style scoped>

</style>
